module.exports = __webpack_public_path__ + "img/adhka-yx1zn.014.7e9eca08.png";